















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class ConfirmDeleteModal extends Vue {
    @Prop({ required: true, type: String })
    message!: string;

    @Prop({ default: '', type: String })
    name!: string;

    @Prop({ default: '', type: String })
    title!: string;

    @Prop({ default: 'OK', type: String })
    okTitle!: string;

    @Prop({ default: 'Cancel', type: String })
    cancelTitle!: string;

    @Prop({ default: 5, type: Number })
    countdownSeconds!: number;

    visible = false;

    confirmed = false;

    secondsLeft = 0;

    private countdownInterval = 0;

    created(): void {
        this.secondsLeft = this.countdownSeconds;
    }

    mounted(): void {
        this.visible = true;
        this.countdownInterval = window.setInterval(() => {
            this.secondsLeft -= 1;

            if (this.secondsLeft <= 0) {
                window.clearInterval(this.countdownInterval);
            }
        }, 1000);
    }

    beforeDestroy(): void {
        window.clearInterval(this.countdownInterval);
    }

    // The part of the message before and after the {name} placeholder;
    // the name itself is rendered in bold between them.
    get messageParts(): string[] {
        return this.message.split('{name}');
    }

    get okButtonLabel(): string {
        return this.secondsLeft > 0 ? `${this.secondsLeft}s (${this.okTitle})` : this.okTitle;
    }
}
